export class Poller<T>{
    private startTime: number;
    public stop: boolean;
    public resetTimer = () => {
      this.startTime = performance.now();
    }
    public async runAsync<T>(fn: () => Promise<T>, delayMs: number, timeoutMs?: number) {
      let result = await fn();
      this.startTime = performance.now();
      while (!this.stop && (!timeoutMs || (performance.now() - this.startTime) < timeoutMs)) {
        await this.wait(delayMs);
        result = await fn();
      }
      return result;
    }
      
    private wait(ms: number = 1000) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
      } 
}